import React from 'react';
import {Card, Spacer, Text} from 'components';
import {Table} from 'schema';
import {bookSchema, sampleBooks, tableConfiguration} from './demoSchema';

/**
 * Table mode: a list of entities rendered with `<Table />`. The same
 * `bookSchema` defines the columns; `tableConfiguration.defaultColumns`
 * selects which parts are shown and in what order.
 */
export const TablePage: React.FC = () => {
  return (
    <>
      <Text variant="body1" kind="secondary">
        {'A list of entities rendered with <Table />. Columns, formatting and ' +
          'filtering are derived from the same schema.'}
      </Text>
      <Spacer size={2} />
      <Card level="level3">
        <Card.Header>
          <Text variant="h2" kind="primary">
            {'Books'}
          </Text>
        </Card.Header>
        <Card.Content>
          <Table
            header={`${sampleBooks.length} books`}
            schema={bookSchema}
            data={sampleBooks}
            configuration={tableConfiguration}
          />
        </Card.Content>
      </Card>
    </>
  );
};
